import React from 'react';
import { FOOTER_HEIGHT } from 'components/ListingTable/BasicListingTable';
import MyBrokerageTabs from './MyBrokerageTabs';
import MyBrokerageLayout from './MyBrokerageLayout';
import { MyBrokerageContextProvider } from './MyBrokerageContext';
import TableFooter from './TableFooter';

const MyBrokeragePage: React.FC = () => (
  <MyBrokerageContextProvider>
    <MyBrokerageLayout>
      <MyBrokerageTabs />
      <TableFooter height={FOOTER_HEIGHT} />
    </MyBrokerageLayout>
  </MyBrokerageContextProvider>
);

export default MyBrokeragePage;
